"use strict";

import * as display from "./display.js";

const news = document.querySelectorAll(".card-new");
const gamesContent = document.querySelectorAll(".games__content");
const gameOptions = document.querySelectorAll(".points__header-options");
const scheduleSort = document.querySelector(".sch__header-input");
const mainNav = document.querySelector(".nav");
const teamLogo = document.querySelectorAll(".header__logo-img");
const header = document.querySelector(".header");
const headerContainer = document.querySelector(".header__container");
const heroSection = document.querySelector(".hero");
const newsSection = document.getElementById("news");
const card1 = document.querySelector(".news__card-1");

if (window.innerWidth <= 1456) {
  document.querySelector(".container__news").classList.add("news-hide");
  document.querySelector(".row").classList.remove("carousel-hide");
} else {
  document.querySelector(".container__news").classList.remove("news-hide");
  document.querySelector(".row").classList.add("carousel-hide");
}

window.addEventListener("resize", function (e) {
  if (window.innerWidth <= 1456) {
    document.querySelector(".container__news").classList.add("news-hide");
    document.querySelector(".row").classList.remove("carousel-hide");
  } else {
    document.querySelector(".container__news").classList.remove("news-hide");
    document.querySelector(".row").classList.add("carousel-hide");
  }
});

///////////////////////////////////////
// Display news
display.activeGame(1);
display.bothTeams(1);
if (card1) {
  card1.classList.add("card__news--active");
}

newsSection.addEventListener("click", function (e) {
  e.preventDefault();

  const carousel = e.target.closest(".carousel");

  if (!carousel) {
    const click = e.target.closest(".card-new");

    if (click.classList.contains("card-new")) {
      news.forEach((c) => c.classList.remove("card__news--active"));
      gamesContent.forEach((game) =>
        game.classList.remove("games__content--active")
      );

      click.classList.add("card__news--active");

      document
        .querySelector(`.games__content--${click.dataset.tab}`)
        .classList.add("games__content--active");

      display.bothTeams(click.dataset.tab);
    }
  }

  if (carousel) {
    if (e.target.classList.contains("carousel-control-next-icon")) {
      display.carouselOnNext(e);
    }

    if (e.target.classList.contains("carousel-control-prev-icon")) {
      display.carouselOnPrev(e);
    }
  }

  return;
});

///////////////////////////////////////
// Display poitns based on team
gameOptions.forEach((options) => {
  options.addEventListener("click", function (e) {
    const gameContent = e.target.closest(".games__content");
    const gameNumber = gameContent.dataset.tab;

    document.querySelectorAll(".points__row").forEach((row) => row.remove());

    if (e.target.classList.contains("poitns-all")) {
      display.bothTeams(gameNumber);
    }

    if (e.target.classList.contains("poitns-home")) {
      display.home(gameNumber);
    }

    if (e.target.classList.contains("poitns-away")) {
      display.away(gameNumber);
    }
  });
});

///////////////////////////////////////
// Display Standing
display.standing();

///////////////////////////////////////
// Display Schedule
display.schedule();

///////////////////////////////////////
// Display games based on home or away
scheduleSort.addEventListener("change", function (e) {
  document
    .querySelectorAll(".sch__container-row")
    .forEach((row) => row.remove());

  const homeAway = e.target.value;
  display.schedule(homeAway);
});

///////////////////////////////////////
// Smooth scrolling from main navigation
mainNav.addEventListener("click", function (e) {
  e.preventDefault();

  if (e.target.classList.contains("nav__link")) {
    const id = e.target.getAttribute("href");
    document.querySelector(id).scrollIntoView({ behavior: "smooth" });
  }
});

///////////////////////////////////////
// Smooth scrolling to page from teams logo
teamLogo.forEach((nav) => {
  nav.addEventListener("click", function (e) {
    e.preventDefault();

    const anchor = e.target.closest("a");
    const page = anchor.getAttribute("href") + "header";

    document.querySelector(page).scrollIntoView({ behavior: "smooth" });
  });
});

///////////////////////////////////////
// Nav fade animation
header.addEventListener("mouseover", display.fadeNavigationButtons.bind(0.5));

header.addEventListener("mouseout", display.fadeNavigationButtons.bind(1));

///////////////////////////////////////
// Sticky navigation
const heroHeight = heroSection.getBoundingClientRect().height;

const headerObserver = new IntersectionObserver(display.stickyNav, {
  root: null,
  threshold: 0,
  rootMargin: `${heroHeight}px`,
});

if (window.innerWidth > 704) {
  headerObserver.observe(headerContainer);
}

///////////////////////////////////////
// Mobile navigation
headerContainer.addEventListener("click", function (e) {
  e.preventDefault();

  if (e.target.classList.contains("mobile__icon")) {
    const mobileNavBtn = e.target;

    if (mobileNavBtn.name === "menu-outline") {
      const icons = document.querySelectorAll(".mobile__icon");
      icons.forEach((el) => el.classList.remove("mobile__icon_hide"));
      mobileNavBtn.classList.add("mobile__icon_hide");

      document.querySelector(".mobile__background").style.transform =
        "scale(80)";

      const mobileNav = document.querySelector(".mobile__nav");
      mobileNav.style.opacity = 1;
      mobileNav.style.pointerEvents = "auto";
      mobileNav.style.visibility = "visible";
    }

    if (mobileNavBtn.name === "close-outline") {
      const icons = document.querySelectorAll(".mobile__icon");
      icons.forEach((el) => el.classList.remove("mobile__icon_hide"));
      mobileNavBtn.classList.add("mobile__icon_hide");

      document.querySelector(".mobile__background").style.transform =
        "scale(0)";

      const mobileNav = document.querySelector(".mobile__nav");
      mobileNav.style.opacity = 0;
      mobileNav.style.pointerEvents = "none";
      mobileNav.style.visibility = "hidden";
    }
  }

  if (e.target.classList.contains("nav__link")) {
    const id = e.target.getAttribute("href");
    const mobileIcons = document.querySelectorAll(".mobile__icon");
    if (!mobileIcons[1].classList.contains("mobile__icon_hide")) {
      const mobileNav = document.querySelector(".mobile__nav");
      mobileNav.style.opacity = 0;
      mobileNav.style.pointerEvents = "none";
      mobileNav.style.visibility = "hidden";

      document.querySelector(".mobile__background").style.transform =
        "scale(0)";

      mobileIcons.forEach((el) => el.classList.add("mobile__icon_hide"));
      mobileIcons[0].classList.remove("mobile__icon_hide");
    }

    document.querySelector(id).scrollIntoView({ behavior: "smooth" });
  }

  return;
});
